"use client";

import { useState } from "react";

const fieldClass =
  "w-full rounded-xl border border-[#37373f] bg-[#1f1f24] px-3.5 py-3 text-[15px] text-[#f3f3f5] placeholder:text-[#8b8b96] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/25";

/** Isolated client island — only toggles password visibility. */
export function PasswordField({
  name = "password",
  placeholder = "Passwort",
  autoComplete = "current-password",
  required = true,
  minLength,
}: {
  name?: string;
  placeholder?: string;
  autoComplete?: string;
  required?: boolean;
  minLength?: number;
}) {
  const [show, setShow] = useState(false);

  return (
    <div className="relative">
      <input
        type={show ? "text" : "password"}
        name={name}
        required={required}
        minLength={minLength}
        autoComplete={autoComplete}
        placeholder={placeholder}
        className={`${fieldClass} pr-11`}
      />
      <button
        type="button"
        title={show ? "Passwort verbergen" : "Passwort anzeigen"}
        aria-label={show ? "Passwort verbergen" : "Passwort anzeigen"}
        onClick={() => setShow((v) => !v)}
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-md p-1 text-[#8b8b96] hover:text-[#f3f3f5]"
      >
        {show ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" />
            <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
            <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-4.86" />
            <path d="m2 2 20 20" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  );
}
